module.exports = __webpack_public_path__ + "img/changeAllocation-2@2x.e6d3048.png";